module.exports = {
	meta:{
		keyWords:'CTExcel，中国电信，香港电信，香港储值卡，香港手机卡，香港旅游，香港留学，香港流量，香港签证，学生套餐，免费领卡，学生卡，体验卡',
		description:'中国电信CTExcel赴港留学生专享优惠活动，是针对为在香港留学生提供优质的移动通讯服务，新用户可免费领卡体验。CTExcel所拥有的大学生专属及高速本地流动通讯计划等特色业务将使您的在香港生活更加便捷美好。',
	},
	index: {
		
		right: {//右侧悬浮框
			phone: '激活',
			order: '物流<br/>查询',
			share: '分享',
			weibo: '微博',
			weChat: '微信',
			facebook: 'Facebook',
			copy: '复制',
			shareList:{
				weiChatText:'扫描二维码，分享优惠活动'
			}
		},
		getNewCard:{
			phoneCard:'手机卡',
			phoneDate1:'香港高速数据',
			phoneDate2:'中国内地数据',
			phoneTalk:'香港本地或IDD致电内地',
			freeCard1:'我还没有SIM卡',
			freeCard2:'免费领取手机卡',
			orderPkg1:'我已经领取SIM卡',
			orderPkg2:'购优惠套餐',
		},
		toCardInfo:"查看体验卡详情 >",
		advantage:{
			h3: '我们的优势',
			linkText: '查看香港数据及语音储值卡2018体验卡详情',
			title:'更多精彩',
			tipList:[
				{text:"CTExcel 4G LTE信号现已覆盖全港，高速稳定。通话信号强劲，语音音质清晰，不掉线不串线。"},
				{text:"AlipayHK APP、微信香港钱包一键充值缴费，支付宝、银联、Visa/Master、PayPal多种在线支付方式便利生活"},
				{text:"面向不同的使用人群，如学生、商旅人士和旅游者，CTExcel提供多款贴合用户使用习惯的套餐服务。套餐同时分为合约制和非合约制，满足用户长短期的使用需求。"},
				{text:"我们的客服人员可使用普通话、粤语和英语三种语言与您交流，快速解答您的疑问。"}
			],
			advantageList:[
				{listText:'4G覆盖'},
				{listText:'灵活支付'},
				{listText:'个性套餐'},
				{listText:'三语客服'}
			],
			msgList: [
				{top: '福利',tip1: '凭CTExcel电话号码登记',tip2: 'AlipayHK领取新生大礼',tip3: '“港版支付宝”迎新礼'},
				{top: '特惠',tip1: '学生体验卡专享',tip2: '大流量服务组合',list: ['免签约','免住址证明','大流量随心用']},
				{top: '超值',tip1: '可转换大学生月费计划',list: ['· 每月<span style="color: #ff861e;font-weight: 700;">免行政费 HK$18</span>','· 每月<span style="color: #ff861e;font-weight: 700;">送一日</span>中国内地数据漫游 ','· 每月<span style="color: #ff861e;font-weight: 700;">送100分钟</span>致电内地IDD']},
				{top: '赏你赏他推荐码',tip1: '推荐一位朋友成功上台，即<span style="color: #ff861e;font-weight:700;">「赏」12GB数据!</span> 「赏」你6GB，「赏」他6GB!'}
			],
		},
		strategyStep:{
			title:'活动参与攻略',
			tip:'轻轻松松，三步搞定',
			stepList:[
				{name:"学生专享 $0电话卡",btntext:"免费领卡",url:"#/fillInfo",class:""},
				{name:"电话卡寄送到家直达手中",btntext:"激活手机卡",url:"https://www.ctexcel.com.hk/toActivate",class:""},
				{name:"免费领卡赠送的套餐，已经用完啦",btntext:"购优惠套餐",url:"#/pkgList",class:""},
			],
		}
	},
	footer: '*活动最终解释权归中国电信国际有限公司所有',
	btn: {
		next: '下一步',
		sure: '确定',
		pay: '立即支付',
		order: '立即抢购',
		act_back: '返回活动首页 >',
		return_last: '返回上一步',
		receive: '立即领取',
		trans: '立即转换',
		active: '去激活',
	},
	countrys: {
		china: '中国大陆',
		hk: '香港特别行政区',
	},
	//赏你赏他弹窗内容
	awardInfo: {
		title: '大学生赏你赏他',
		title_tip1: '「大学生赏你赏他」推荐计划',
		tip1: '现有客户推荐一位朋友成功上台，即「赏」12GB数据! 「赏」你6GB，同时「赏」他6GB!推荐人(现有客户): 赏6GB香港本地数据，「被推荐人」(新客户): 赏6GB香港本地数据',
		title_tip2: '活动详情',
		tip2: '「大学生本地」计划–羽量级2018/轻量级2018/重量级2018之现有客户(「推荐人」) 于推广期内推荐客户透过开新号码/携号转台（「被推荐人」）成功申请「大学生本地」计划–羽量级2018/轻量级2018/重量级2018及输入专属推荐码（「推荐码」），「推荐人」及「被推荐人」均可于合约期内第7至第12个月连续6个月，免费获赠每月1GB额外香港本地数据(即每人合共获赠6GB)。「推荐人」可将「大学生本地」计划–羽量级2018/轻量级2018/重量级2018「确认电邮」内之「推荐码」给予符合资格之「被推荐人」。',
		time: '活动推广期由即日起至2019年6月30日',
		title_tip3: '「大学生赏你赏他」推荐计划之条款及细则：',
		tip3: [
			{label:'1）「大学生赏你赏他」推荐计划（「推荐计划」）只适用于「大学生本地」计划–轻量级2018/轻量级2018/重量级2018，「推荐人」及「被推荐人」不能为同一人。'},
			{label:'2）「被推荐人」成功登记服务后，「推荐人」及「被推荐人」均可于合约期内第7至第12个月连续6个月，免费获赠每月1GB额外香港本地数据（即每人合共获赠6GB）。',child_list: ['i)	「推荐人」及「被推荐人」免费获赠每月1GB之额外香港本地数据不可累积使用。由于「推荐人」可于推广期内获得最多5个推荐名额，如成功推荐5位「被推荐人」，则每月最多可享免费5GB之额外香港本地数据，','ii)	若有任何剩余免费获赠之香港本地数据，将于当月底23:59自动取消，恕不另行通知。']},
			{label:'3）「推荐人」必须为「大学生本地」计划–轻量级2018/轻量级2018/重量级2018之现有客户，「被推荐人」必须于推广期内透过开新号码/携号转台成功申请「大学生本地」计划–轻量级2018/轻量级2018/重量级2018（合约期12个月）及输入专属推荐码（「推荐码」）。'},
			{label:'4）「推荐人」及「被推荐人」须符合之要求：', child_list: ['i)	已登记选用「大学生本地」计划–轻量级2018/轻量级2018/重量级2018；','ii)	流动通信服务计划仍然生效；','iii)	「推荐人」必须为「中国电信CTExcel」现有客户（不适用于企业客户）。','iv)	「推荐人」必须于活动推广期内及于「被推荐人」申请及递交指定服务计划合约前，发送其专属推荐码（「推荐码」）予「被推荐人」。','v)	「被推荐人」以香港身份证或有效之护照登记选用指定服务计划及签署期限合约。','vi)	「被推荐人」选用指定服务计划时必须输入由「推荐人」提供之有效「推荐码」。','vii)	「被推荐人」之账户于服务计划生效日起计100日后仍维持生效及无拖欠任何帐项纪录。']},
			{label:'5）「推荐计划」推广期由2018年7月20日至2019年6月30日，包括首尾两天。'},
			{label:'6）「推荐人」可于推广期内获得最多5个推荐名额。「被推荐人」成功透过开新号码/携号转台选购指定月费时，有关推荐名额会即时被扣除。'},
			{label:'7）若「被推荐人」于合约期内终止合约，则无法继续享用此优惠，且需要按照合约上的规定赔偿有关款项；而「推荐人」不会售到任何影响。'},
			{label:'8）所有推荐奖赏不可转让他人、退回、转换或兑换为现金。'},
			{label:'9）欲查询「推荐计划」之详情及优惠，请登入「中国电信CTExcel」官方站点<a href="www.ctexcel.com.hk">www.ctexcel.com.hk</a> 之活动页面或致电24小时客户服务热线（+852）5749 9868。'},
			{label:'10）除特别注明外，上述月费优惠不可与其他推广优惠同时使用。'},
			{label:'11）如有合理怀疑「推荐人」以非法、诈骗或其他不良手法推荐上台，「中国电信CTExcel」将有权取消「推荐人」参加本「推荐计划」的资格。'},
			{label:'12）「中国电信CTExcel」保留随时更改、更新或终止所有优惠，以及修订所述任何条款及细则之权利，而不予事先通知。如有任何争议，「中国电信CTExcel」保留最终决定权。'},
		],
	},
	//信息填写页面
	fillInfo: {
		title_per: '填写个人信息',
		title_send: '填写收货地址',
		user_cname: '中文姓名',
		user_ename: '英文姓名（选填）',
		email: '邮箱',
		school_name: '学校名称',
		code: '活动推荐码',
		codeDes:[
			'奖励是什么？',
			'填写推荐码，并成功转换为校园棒棒糖2019计划（少糖级/半糖级/全糖级/少糖级之早鸟/半糖级之早鸟/全糖级之早鸟任一个），双方均可获得6GB流量（合约期内第7至第12个月连续6个月，免费获赠每月1GB额外香港本地数据）；',
			'如何获得？',
			'购买/转换校园棒棒糖2019计划（少糖级/半糖级/全糖级/少糖级之早鸟/半糖级之早鸟/全糖级之早鸟任一个）即可获得推荐码。',
		],
		reach_date: '预计赴港日期（选填）',
		phone: '联系电话',
		send_address: '寄送地区',
		address: '详细地址',
		rules: {
			user_cname1: '请填写您的中文姓名',
			user_cname2: '请输入中文字符',
			user_ename: '请输入英文字符',
			school_name: '请选择就读学校',
			email1: '请填写您的邮箱',
			email2: '请输入正确邮箱以便查收确认邮件',
			code: '您填写的推荐码格式不对',
			file_name: '请上传学生录取通知书',
			phone1: '请填写联系电话',
			phone2: '请输入正确的联系电话',
			zone1: '请选择省',
			zone2: '请选择区/域',
			district1: '请选择市',
			district2: '请选择区',
			area: '请选择县',
			address1: '请填写您的详细地址',
			address2: '请填写正确的室、楼、住宅名称（不允许填写特殊字符）',
		},
		checkboxs: {
			one: '本人同意贵公司使用本人的个人资料作直接促销用途，并希望接受任何推广及直接促销通讯',
			two: '我同意并接受服务条款的所有内容'
		},
		pop: {
			title: '信息确认',
			title_per: '个人信息',
			title_send: '收货地址',
		},
		imgTip: '请务必提供真实有效的相关证件， 以免审核不通过耽误您的使用。',
		service_rule: [//服务条款
			'1、 「校园棒棒糖推广活动」 一 免费中国电信CTExcel「香港数据及话音储值卡2019体验版」优惠(「校园棒棒糖推广活动」)之登记期由即日起至2019年12月31日，包括首尾两日，名额有限，额满即止。',
			'2、 「校园棒棒糖推广活动」只适用于指定及持有香港可颁授学位的高等教育院校所发出之录取通知书(「录取通知书」)之学生。',
			'3、 免费中国电信CTExcel「香港数据及话音储值卡2019体验版」之申请及激活方法:<ul><li>i) 如客户通过「寄托网」或指定之高校学生团体获取中国电信CTExcel「香港数据及话音储值卡2019体验版」，有关客户身份认证及SIM卡物流运送之事宜，详情请咨询「寄托网」或指定之高校学生团体。当用户收到SIM卡后，必须于中国电信CTExcel官方网站(www.ctexcel.com.hk )之「校园棒棒糖推广活动」页面输入SIM卡之ICCID及所需之个人资料进行SIM卡激活，成功激活后会收到「确认启动」之电邮。</li><li>ii) 如客户通过中国电信CTExcel官方网站直接登记申请获取免费中国电信CTExcel「香港数据及话音储值卡2019体验版」，用户需要填写指定之个人资料，提供有效之「录取通知书」副本作爲凭证，成功提交后，经内部确认核实资料无讹，方可获取「香港数据及话音储值卡2019体验版」一张。</li></ul>',
			'如用户于2019年12月31日香港时间23时59分尚未进行SIM卡激活，SIM卡将随即自动失效，并视为主动放弃「校园棒棒糖推广活动」。',
			'4、 每个有效「录取通知书」只可以申请免费中国电信CTExcel「香港数据及话音储值卡2019体验版」1次。',
			'5、 以上优惠不可与其他优惠同时使用或兑换现金。',
			'6、 客户亦同意遵守中国电信CTExcel「香港数据及话音储值卡2019体验版」之条款及细则。',
			'7、 中国电信国际有限公司(「中国电信国际」)有权更改相关之条款及细则，恕不另行通知，并有权更改或终止任何优惠。如有任何争议，中国电信国际将保留一切最终决定权。'
		],
	},
	//领卡成功页面
	getCardSuccess: {
		top: {
			title: '您的手机卡领取申请已提交',
			order_id: '订单号：',
			freight: '运费：',
			tip: '请耐心等待，确认结果将会已邮件形式通知给您，确认通过后手机卡将尽快寄送给您。',
		},
		attention: {
			tip1: '关注官方微信公众号“中国电信CTExcelHK”，话费账单轻松查，套餐用量实时看。',
			tip2: '如有任何疑问请致电服务热线<br />24小时客服电话+852 5749 9868'
		},
		rules_title: '活动规则',
		rules: [
			'1、大学生推广活动 一 免费中国电信CTExcel「香港数据及话音储值卡2018体验版」优惠(「大学生2018推广活动」)之登记期由即日起至2018年9月30日，包括首尾两日，名额有限，额满即止',
			'2、「大学生2018推广活动」只适用于指定及持有香港可颁授学位的高等教育院校所发出之录取通知书(「录取通知书」)之学生。',
			'3、免费中国电信CTExcel「香港数据及话音储值卡2018体验版」之申请及激活方法:',
			'<ul style="margin-left:20px;"><li>· 如客户通过「寄托网」或指定之高校学生团体获取中国电信CTExcel「香港数据及话音储值卡2018体验版」，有关客户身份认证及SIM卡物流运送之事宜，详情请咨询「寄托网」或指定之高校学生团体。当用户收到SIM卡后，必须于中国电信CTExcel官方网站(<a href="https://www.ctexcel.com.hk">www.ctexcel.com.hk</a>)之「大学生2018推广活动」页面输入SIM卡之ICCID及所需之个人资料进行SIM卡激活，成功激活后会收到「确认启动」之电邮。</li><li>· 如客户通过中国电信CTExcel官方网站直接登记申请获取免费中国电信CTExcel「香港数据及话音储值卡2018体验版」，用户需要填写指定之个人资料，提供有效之「录取通知书」副本作为凭证，成功提交后，经内部确认核实数据无讹，方可获取「香港数据及话音储值卡2018体验版」一张。<br/>如用户于2018年9月30日香港时间23时59分尚未进行SIM卡激活，SIM卡将随即自动失效，并视为主动放弃「大学生2018推广活动」。</li></ul>',
			'4、每个有效「录取通知书」只可以申请免费中国电信CTExcel「香港数据及话音储值卡2018体验版」1次。',
			'5、以上优惠不可与其他优惠同时使用或兑换现金。',
			'6、客户亦同意遵守中国电信CTExcel「香港数据及话音储值卡2018体验版」之条款及细则。',
			'7、中国电信国际有限公司(「中国电信国际」)有权更改相关之条款及细则，恕不另行通知，并有权更改或终止任何优惠。如有任何争议，中国电信国际将保留一切最终决定权。'
		],
		pkg_title: '还差一步，就可领取到优惠大流量服务组合！',
		listTip: '温馨提示：以上大流量服务组合可以叠加购买',
	},
	//支付确认页面
	pay: {
		title: '请选择支付方式',
	},
	//支付结果页面
	payResult: {
		suc: {
			title: '恭喜您 订购成功',
			order_id: '订单号：',
			auth_code: '认证码：',
			pkgName: '套餐名称：',
			amount: '支付金额：',
			act_title: '激活攻略',
			tips: [
				'关注官方微信公众号',
				'“中国电信CTExcelHK”',
				'话费账单轻松查，套餐用量实时看',
				'如有任何疑问请致电服务热线',
				'24小时客服电话+852 5749 9868'
			]
		},
		fail: {
			title: '支付失败',
			tips: [
				'如不是以上原因，请致电服务热线',
				'24小时客服电话+852 5749 9868'
			]
		}
	},
	//输入iccid
	inputIccid: {
		rules: {
			iccid1:'请填写ICCID',
			iccid2:'请输入正确的19位数字，不包含F',
		},
		errMsg: {
			code1: 'iccid不存在，请重新输入',
			code2: 'iccid不在活动范围',
			code3: '用户未激活,请先去官网激活',
			code5: '失败(其他)，请重新输入',
		}
	},
	//套餐列表页
	pkgList: {
		title: '大流量服务组合',
		title_tip: '免签约  ·  免住址证明  ·  大流量随心用',
		top_tip: '还没手机卡？点击这里',
		tranPkg: {
			title: '转换月费计划',
			title_tip: '先使用，后付账，套餐种类更齐全！',
			top: '什么是月费计划？',
			top_ans: '月费计划即月付通讯套餐',
		},
		stuTip1: '每月$18行政费',
		stuTip2: '每月赠送HK$18 特惠IDD致电中国内地100分钟',
		stuTip3: '每月赠送1日中国内地「数据漫游Day Pass」(价值: HK$576)',
		period: '合约期',
		
	},
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js